/**
 * 授权币确定模态框
 */

import AuthCoin from './AuthCoin.vue';

export default AuthCoin;